import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/app'
import { msalReady } from '@/app/auth/msal-instance'
import '@/styles/globals.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found')

/**
 * MSAL 3.x requires `initialize()` to resolve before the React tree touches
 * `MsalProvider`. Awaiting the shared promise here (rather than in the
 * component) avoids a race where the first render acquires a token against a
 * half-initialised instance.
 */
void msalReady.then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
